var _rect, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLiveNow = function SvgLiveNow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_209_65",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 46
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 46,
    height: 46,
    rx: 12,
    fill: "#FFF6E0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_209_65)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 46,
    height: 46,
    rx: 12,
    fill: "#FFF6E0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_65)",
    filter: "url(#filter0_d_209_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2711 31.8003L24 30.2769L18.7289 31.8003C18.6832 31.8917 18.668 31.9831 18.668 32.0898V35.2382H29.332V32.0898C29.332 31.9831 29.3168 31.8917 29.2711 31.8003Z",
    fill: "#C05C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2383 11.5234H32.3462C32.3529 11.2661 32.3789 11.0237 32.3789 10.7617C32.3789 10.3351 32.0438 10 31.6172 10H16.3828C15.9562 10 15.6211 10.3351 15.6211 10.7617C15.6211 11.0237 15.6471 11.2661 15.6537 11.5234H11.7617C11.3407 11.5234 11 11.8641 11 12.2852V14.2147C11 18.4679 14.407 21.9229 18.6057 22.1453C19.4804 23.3496 20.5185 24.2434 21.6996 24.7469C21.5168 28.4488 19.3992 31.0234 18.8965 31.5567C18.8203 31.6176 18.7594 31.709 18.7289 31.8004H29.2711C29.2406 31.709 29.1797 31.6176 29.1035 31.5567C28.5855 31.0234 26.4832 28.4641 26.3004 24.7469C27.4818 24.2433 28.5261 23.3493 29.4016 22.1445C33.5966 21.9185 37 18.4655 37 14.2147V12.2852C37 11.8641 36.6593 11.5234 36.2383 11.5234V11.5234ZM12.5234 14.2147V13.0469H15.7191C15.9168 15.5645 16.4627 18.2309 17.6102 20.4969C14.7339 19.8492 12.5234 17.2842 12.5234 14.2147V14.2147ZM35.4766 14.2147C35.4766 17.2826 33.268 19.8464 30.3939 20.4956C31.5323 18.2297 32.0813 15.589 32.2809 13.0469H35.4766V14.2147Z",
    fill: "#FFAC60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2155 19.6889L24 19.0573L22.7845 19.6889C22.5301 19.8198 22.2191 19.7982 21.9856 19.6294C21.752 19.4598 21.6345 19.1727 21.6821 18.8885L21.9052 17.5354L20.9308 16.5736C20.7187 16.3668 20.6538 16.0602 20.7404 15.7955C20.8296 15.5217 21.0662 15.3209 21.3518 15.2778L22.7057 15.0739L23.3186 13.8488C23.5775 13.3326 24.4225 13.3326 24.6814 13.8488L25.2943 15.0739L26.6481 15.2778C26.9338 15.3209 27.1703 15.5218 27.2596 15.7955C27.3488 16.07 27.2759 16.3713 27.0691 16.5736L26.0947 17.5354L26.3179 18.8885C26.3655 19.1727 26.248 19.4598 26.0144 19.6294C25.7823 19.7975 25.472 19.8223 25.2155 19.6889V19.6889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0938 36H17.9062C17.4852 36 17.1445 35.6593 17.1445 35.2383C17.1445 34.8173 17.4852 34.4766 17.9062 34.4766H30.0938C30.5148 34.4766 30.8555 34.8173 30.8555 35.2383C30.8555 35.6593 30.5148 36 30.0938 36Z",
    fill: "#B35600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_209_65",
    x: 0,
    y: 3,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.597333 0 0 0 0 0.370833 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_209_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_209_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_65"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(11 10)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLiveNow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/liveNow.015e964538f045e67fa34247ef30ee62.svg";